import React from "react";
import Profile from "../../components/user/Profile";
import "../../styles/user/Profile.css";

const ProfilePage = () => {
  return (
    <div className="profile-page">
      <Profile />
    </div>
  );
};

export default ProfilePage;
